export default "__VITE_ASSET__Bbz$FPFi__"